<div class="routing-rules">

  <sc-master-detail [selection]="[selectedRule]" [data]="rules" (selectionChanged)="onSelectionChanged($event);" [newStyle]="true"
    (addEntry)="onAddEntry($event);" (deleteEntry)="onDeleteEntry($event);">

    <form #routingRulesForm="ngForm" class="form">
      <ng-container *ngIf="workingCopyRule != null">
        <sc-flex>

          <mat-form-field appearance="fill" class="field-name">
            <mat-label>
              {{'rule name' | translate: ['tmc.admin.routing-rule.rule.name', translationService.language]}}
            </mat-label>
            <input matInput [(ngModel)]="workingCopyRule.name" #ctrlName="ngModel" name="rr_name" [required]="true"
              [maxlength]="255">
          </mat-form-field>

          <sc-content-spacer></sc-content-spacer>

          <mat-form-field class="field-transport-option" appearance="fill">
            <mat-label>
              {{'transport option' | translate: ['tmc.admin.routing-rule.rule.transport-option',
              translationService.language]}}
            </mat-label>
            <mat-select [(ngModel)]="workingCopyRule.transportOptionId" name="rr_transport_option"
              #ctrlTransportOption="ngModel" [required]="true">

              <ng-container *ngFor="let to of transportOptions">
                <mat-option [value]="to.id">
                  {{to.name | translate:[to.name, translationService.language]}}
                </mat-option>

                <ng-container *ngFor="let child of to.children">
                  <mat-option [value]="child.id">
                    &nbsp;&nbsp;{{child.name | translate:[child.name, translationService.language]}}
                  </mat-option>
                </ng-container>

              </ng-container>

            </mat-select>
          </mat-form-field>

          <sc-content-spacer></sc-content-spacer>

          <mat-form-field appearance="fill">
            <mat-label>{{'sort order' | translate: ['tmc.admin.routing-rule.rule.sort-order',
              translationService.language]}}</mat-label>
            <input matInput [(ngModel)]="workingCopyRule.sortOrder" #ctrlSortOrder="ngModel" name="rr_sortOrder"
              [required]="false" [maxlength]="10">
          </mat-form-field>

        </sc-flex>
        <div class="form-box positions-list">
          <div cdkDropList (cdkDropListDropped)="drop($event)">
            <div class="draggable-form-box grid" cdkDrag *ngFor="let position of workingCopyRule.positions">

              <div class="row-flex" style="grid-column: 1; grid-row: 1;">
                <mat-form-field class="grow">
                  <input matInput [(ngModel)]="position.stationName" #ctrlPositionSelectStation="ngModel"
                    name="{{getPositionSelectStationFieldName(workingCopyRule, position)}}"
                    placeholder="{{'station selection' | translate: ['tmc.admin.routing-rule.position.select-station', translationService.language]}}"
                    [required]="true" [readonly]="true">
                </mat-form-field>

                <button mat-icon-button type="button" (click)="assignStation(position, form)"
                  class="small-button assign-button"><sc-icon iconClass="fa-sitemap"></sc-icon></button>
              </div>
              <mat-form-field style="grid-column: 2; grid-row: 1;" class="action-type-field">
                <mat-label>
                  {{'actionType' | translate: ['tmc.admin.routing-rule.position.action-type',
                  translationService.language]}}
                </mat-label>
                <mat-select [(ngModel)]="position.actionType" required="true"
                  name="{{getPositionActionTypeFieldName(workingCopyRule, position)}}"
                  [disabled]="isActionTypeDisabled(position)">
                  <mat-option *ngFor="let o of actionTypeOptions" value="{{o.option}}">
                    {{o.name | translate: ['tmc.admin.routing-rule.position.action-type.' + o.name,
                    translationService.language]}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field style="grid-column: 3; grid-row: 1;" class="action-type-field">
                <mat-select [(ngModel)]="position.processingStatusModel" name="processingStatusModel"
                  placeholder="{{'processing status model' | translate: ['tmc.admin.routing-rule.position.processingstatusmodel', translationService.language]}}">
                  <mat-option [value]="null">
                    {{' no processing model' | translate: ['tmc.stationgroup.no-processing-model',
                    translationService.language]}}
                  </mat-option>
                  <mat-option *ngFor="let statusModel of processingStatusModels" [value]="statusModel.key">
                    {{statusModel.nameDictionaryKey | translate: [statusModel.nameDictionaryKey,
                    translationService.language]}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div class="row-flex" style="grid-column: 4; grid-row: 1;">
                <button mat-icon-button type="button"
                  [matTooltip]="'assigned tasks' | translate: ['tmc.admin.routing-rule.position.assign-tasks', translationService.language]"
                  (click)="assignTasks(position, form)" class="small-button assign-task-button"
                  [ngClass]="{'no-tasks' : !position.tasks || position.tasks.length === 0}">
                  <i class="far fa-tasks"></i>
                </button>
              </div>

              <mat-checkbox style="grid-column: 1; grid-row: 2;" class="form-checkbox"
                [(ngModel)]="position.waitingForRetrieve"
                name="{{getPositionWaitingForRetrieveCheckboxName(workingCopyRule, position)}}"
                [disabled]="isWaitingForRetrieveDisabled(position)">
                {{'waiting for retrieve' | translate: ['tmc.admin.routing-rule.position.waiting-for-retrieve',
                translationService.language]}}
              </mat-checkbox>

              <mat-checkbox style="grid-column: 2; grid-row: 2;" class="form-checkbox"
                [(ngModel)]="position.cargoMandatory"
                name="{{getPositionCargoMandatoryCheckboxName(workingCopyRule, position)}}"
                [disabled]="isCargoMandatoryDisabled(position)">
                {{'cargo mandatory' | translate: ['tmc.admin.routing-rule.position.cargo-mandatory',
                translationService.language]}}
              </mat-checkbox>

              <mat-form-field style="grid-column: 3 / span 2; grid-row: 2;">
                <input matInput [(ngModel)]="position.predictedDuration" #predictedDuration="ngModel"
                  name="{{getPredictedDurationFieldName(workingCopyRule, position)}}"
                  placeholder="{{'predicted duration' | translate: ['tmc.admin.routing-rule.rule.predicted-duration', translationService.language]}}"
                  [required]="true" [disabled]="isPredictedDurationDisabled(position)" appPositiveInteger type="number"
                  min="0">
              </mat-form-field>

              <mat-form-field style="grid-column: 1; grid-row: 3;">
                <mat-label>
                  {{'station assignment strategy' | translate: ['tmc.common.entity.station-assignment-strategy',
                  translationService.language]}}
                </mat-label>
                <mat-select [(ngModel)]="position.stationAssignmentStrategy"
                  [required]="isStationAssignmentStrategyRequired(position)"
                  [disabled]="isStationAssignmentStrategyDisabled(position)"
                  name="{{getAssignToProcessingStationFirstFieldName(workingCopyRule, position)}}">
                  <mat-option *ngFor="let o of stationAssignmentStrategyOptions" value="{{o}}">
                    {{o | translate: ['tmc.common.entity.station-assignment-strategy.' + o,
                    translationService.language]}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field style="grid-column: 2 / span 3; grid-row: 3;">
                <input matInput [(ngModel)]="position.hint" name="{{getHintFieldName(workingCopyRule, position)}}"
                  placeholder="{{'hint' | translate: ['tmc.admin.routing-rule.rule.hint', translationService.language]}}"
                  [required]="false" [maxLength]="1024">
              </mat-form-field>

              <div class="button-bar" style="grid-column: 5; grid-row: 1 / span 5;">
                <button mat-icon-button type="button" class="small-button remove-button"
                  (click)="removePosition(position)"><sc-icon iconClass="fa-minus"></sc-icon></button>
              </div>

            </div>
          </div>
        </div>
        <div class="form-box">
          <div class="add-button-wrapper">
            <button type="button" class="add-button" mat-stroked-button (click)="addPosition()"><i
                class="fa-light fa-plus"></i></button>
          </div>
        </div>
      </ng-container>

    </form>

    <ng-template masterDetailToolbar>
      <button mat-stroked-button type="button" (click)="cancel()" [disabled]="cancelDisabled">{{'cancel' | translate:
        ['tmc.admin.routing-rule.action.cancel',
        translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button type="button" (click)="save()" [disabled]="saveDisabled">{{'save' | translate:
        ['tmc.admin.routing-rule.action.save', translationService.language]}}</button>
    </ng-template>

  </sc-master-detail>

</div>
